var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22219(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22219",
    "data-name": "Group 22219",
    transform: "translate(-252 -818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5745",
    "data-name": "Rectangle 5745",
    width: 44,
    height: 44,
    rx: 5,
    transform: "translate(252 818)",
    fill: "#efebff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_9027452_support_icon",
    "data-name": "9027452_support_icon",
    transform: "translate(263.162 829.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27642",
    "data-name": "Path 27642",
    d: "M21.675,10.837H19.266a2.408,2.408,0,0,0-2.408,2.408v2.408a2.408,2.408,0,0,0,2.408,2.408h0a2.408,2.408,0,0,0,2.408-2.408V10.837A10.837,10.837,0,0,0,0,10.837v4.817a2.408,2.408,0,0,0,2.408,2.408h0a2.408,2.408,0,0,0,2.408-2.408V13.246a2.408,2.408,0,0,0-2.408-2.408H0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27643",
    "data-name": "Path 27643",
    d: "M22.429,14v4.817q0,3.612-2.408,3.612H14",
    transform: "translate(-0.754 -0.754)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22219);
export default __webpack_public_path__ + "static/media/Group 22219.3d53defe4fc3acf1e0af7e5272066f44.svg";
export { ForwardRef as ReactComponent };